var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarBusinesshub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C9.25611 6 6.38791 6 3.98348 6.41253C2.83099 6.61027 1.92305 7.45517 1.67561 8.55374C1.28571 10.2848 1.28571 11.8994 1.28571 14.3572C1.28571 16.8149 1.28571 18.4296 1.67561 20.1605C1.92305 21.2592 2.83099 22.104 3.98348 22.3018C6.38791 22.7143 9.25611 22.7143 12 22.7143C14.7439 22.7143 17.6121 22.7143 20.0165 22.3018C21.169 22.104 22.0769 21.2592 22.3243 20.1605C22.7143 18.4296 22.7143 16.8149 22.7143 14.3572C22.7143 11.8994 22.7143 10.2848 22.3243 8.55374C22.0769 7.45517 21.169 6.61027 20.0165 6.41253C17.6121 6 14.7439 6 12 6Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.536 6.05946V4.85715C7.536 2.88469 9.2016 1.28571 11.2562 1.28571H12.7443C14.7989 1.28571 16.4645 2.88469 16.4645 4.85715V6.05946",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 17.0229H15.4286",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 11.8801H15.4286",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBusinesshub);
export default __webpack_public_path__ + "static/media/sidebar_businesshub.a941b9fed4c62a66125d42fd984a1c24.svg";
export { ForwardRef as ReactComponent };